import React, { useRef, useEffect, useState } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import useLangTranslation from "../../../customHooks/languageProvider";
// import FlagPic from "../../../../assets/images/flag.svg";

const ChooseCountry = ({
  showModal,
  closeModal,
  countryList,
  countryCodeType,
  selectedId,
  setSelectedId,
  setSelectedCode,
  handleSave,
}) => {
  const modalRef = useRef();

  const { getLangTranslation } = useLangTranslation();

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  return (
    <>
      <div className="modal fade" tabIndex="-1" ref={modalRef}>
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <h6 className="modal-title text-blue-900">{getLangTranslation("CHOOSE_COUNTRY", "Choose Country")}</h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div
                className="my-5 py-1 pe-3"
                style={{ maxHeight: "40vh", overflow: "auto" }}
              >
                {countryList?.map((item, index) => {
                  return (
                    <label
                      htmlFor={item?.ID}
                      className="d-flex gap-4 align-items-center mb-6 pt-cursor"
                      key={item?.ID}
                    >
                      <h5 className="text-blue-900 mb-0 flex-fill">
                        {item?.CountryName}
                      </h5>
                      <input
                        className="form-check-input m-0"
                        type="radio"
                        value={item?.ID}
                        id={item?.ID}
                        name="LANGUAGE"
                        checked={parseInt(selectedId) === parseInt(item?.ID)}
                        onChange={() => {
                          setSelectedId(item?.ID);
                          setSelectedCode(item?.phone_code);
                        }}
                      />
                    </label>
                  );
                })}
              </div>
              <div className="grid gap-3">
                <button
                  className="btn btn-outline-primary g-col-6"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <span className="btn-upper-case">{getLangTranslation("CANCEL", "Cancel")}</span>
                </button>
                <button
                  className="btn btn-primary g-col-6"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleSave}
                >
                  <span className="btn-upper-case">{getLangTranslation("SAVE", "Save")}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseCountry;
